import React from 'react';
/* --- import Components ----*/
import { Section } from '../Section';
import { SectionTitle } from '../Typography';
import { FeaturesList } from './elements';
import Features from './Features';
import PicturesDisplay from '../LandingPage/PicturesDisplay';
import ButtonScrollToForm from '../LandingPage/ButtonScrollToForm';
/* --- import Data ----*/
import FeaturesData from 'src/data/Features';
/* --- import Style ----*/
import colors from 'src/style/colors';

const FeaturesSection = ({ fromPage, images, landing = false }) => {
  const featuresFiltered = FeaturesData.filter((item) => {
    if (item.page.indexOf(landing ? fromPage + '-landing' : fromPage) !== -1) {
      return item;
    } else return null;
  });

  return (
    <Section theme="secondary" landing={landing}>
      {landing ? (
        <SectionTitle isMobileCenter isCenter css={{ marginBottom: 30, width: '100%' }}>
          Formez-vous en toute confiance&nbsp;!
        </SectionTitle>
      ) : (
        <SectionTitle isMobileCenter isCenter>
          Les <span css={{ color: colors.purple }}>atouts</span> du Reacteur
        </SectionTitle>
      )}
      <FeaturesList landing={landing}>
        {featuresFiltered.map((feature, index) => {
          return (
            <Features
              key={index}
              qty={featuresFiltered.length}
              name={feature.name}
              width="44"
              text={feature.text}
              subtext={feature.subtext}
              light={feature.subtext ? false : true}
            />
          );
        })}
      </FeaturesList>
      {landing && (
        <>
          <PicturesDisplay images={images} />
          <ButtonScrollToForm
            text={
              fromPage === 'reunion'
                ? `Je participe à la réunion d'information\u00A0!`
                : `Je postule\u00A0!`
            }
            margin={landing && fromPage === 'rncp6-alternance' ? true : false}
          />
        </>
      )}
    </Section>
  );
};

export default FeaturesSection;
